import { Space as MantineSpace } from "@mantine/core";

export const Space = MantineSpace;
